import { FunctionComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import { BuySharedFAQAnswer } from './BuySharedFAQAnswer';
import { ExpandingAreaWithReadMore } from 'dibs-elements/exports/ExpandingArea';
import { Link } from 'dibs-elements/exports/Link';

import { BuySharedFAQQuestion_question } from './__generated__/BuySharedFAQQuestion_question.graphql';
import styles from './BuySharedFAQQuestion.scss';

type Props = {
    question: BuySharedFAQQuestion_question | null;
};

export const BuySharedFAQQuestionComponent: FunctionComponent<Props> = ({ question }) => {
    const { title, url, answerCount, id, answers } = question || {};
    if (title && url && id && answers && answerCount) {
        return (
            <li className={styles.question} key={id}>
                <div className={styles.questionHeader}>
                    <Link href={url} className={styles.questionTitle} dataTn="faq-question">
                        {title}
                    </Link>
                    <div className={styles.answerCount} data-tn="faq-answer-count">
                        <FormattedMessage
                            id="BuySharedFAQ.numAnswers"
                            defaultMessage="{answerCount, plural, one {# Answer} other {# Answers}}"
                            values={{ answerCount }}
                        />
                    </div>
                </div>
                <ExpandingAreaWithReadMore buttonClass={styles.button} collapsedHeight={206}>
                    {answers.map(answer =>
                        answer?.serviceId ? (
                            <BuySharedFAQAnswer answer={answer} key={answer.serviceId} />
                        ) : null
                    )}
                </ExpandingAreaWithReadMore>
            </li>
        );
    }
    return null;
};

export const BuySharedFAQQuestion = createFragmentContainer(BuySharedFAQQuestionComponent, {
    question: graphql`
        fragment BuySharedFAQQuestion_question on QuestionType {
            id
            url
            title
            answerCount
            answers {
                serviceId
                ...BuySharedFAQAnswer_answer
            }
        }
    `,
});
